import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import QuoteGenerator from './components/QuoteGenerator';
import FleetSection from './components/FleetSection';
import BenefitsSection from './components/BenefitsSection';
import TestimonialsSection from './components/TestimonialsSection';
import AboutSection from './components/AboutSection';
import FaqSection from './components/FaqSection';
import ContactSection from './components/ContactSection';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <QuoteGenerator />
      <FleetSection />
      <BenefitsSection />
      <TestimonialsSection />
      <AboutSection />
      <FaqSection />
      <ContactSection />
      <Footer />
    </div>
  );
}
